import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { NavigationService } from '../../../core/navigation/navigation.service';
import { NavigationItem } from '../../../core/navigation/navigation-item.interface';
import { NavigationItemComponent } from './navigation-item/navigation-item.component';

@Component({
  selector: 'rms-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  imports: [NavigationItemComponent, AsyncPipe],
})
export class NavigationComponent {
  private navigationService = inject(NavigationService);

  items$: Observable<NavigationItem[]> = this.navigationService.items$;
}
